var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C5.47656 1 1 5.47656 1 11C1 16.5234 5.47656 21 11 21C16.5234 21 21 16.5234 21 11C21 5.47656 16.5234 1 11 1ZM11 19.75C6.17578 19.75 2.25 15.8242 2.25 11C2.25 6.17578 6.17578 2.25 11 2.25C15.8242 2.25 19.75 6.17578 19.75 11C19.75 15.8242 15.8242 19.75 11 19.75ZM11 8.1875C11.5176 8.1875 11.9375 7.76797 11.9375 7.25C11.9375 6.73242 11.5176 6.3125 11 6.3125C10.4824 6.3125 10.0625 6.73047 10.0625 7.25C10.0625 7.76953 10.4805 8.1875 11 8.1875ZM12.875 14.75H11.625V10.375C11.625 10.0312 11.3438 9.75 11 9.75H9.75C9.40625 9.75 9.125 10.0312 9.125 10.375C9.125 10.7188 9.40625 11 9.75 11H10.375V14.75H9.125C8.78125 14.75 8.5 15.0312 8.5 15.375C8.5 15.7188 8.78125 16 9.125 16H12.875C13.2202 16 13.5 15.7202 13.5 15.375C13.5 15.0312 13.2188 14.75 12.875 14.75Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.5cb13ddc9819d01598c015156353635f.svg";
export { ForwardRef as ReactComponent };